import { inject, Injectable } from '@angular/core';
import { DfEventService } from '@df/core/service/df-event';
import { SagepayCloudPaymentService } from '@df/module-sagepay';

@Injectable({
    providedIn: 'root'
})
export class SagepayCloudPaymentServiceDecorator extends SagepayCloudPaymentService {
    private dfEventService = inject(DfEventService);

    constructor() {
        super();
        this.dfEventService.before(event => {
            switch (event.id) {
                case 'nexusCustomerRegister':
                case 'nexusCustomerLogin':
                    if (this.storeId) {
                        this.displaySagepayMessage();
                        event.stopped = true;
                    }
                    break;
                case 'nexusCustomerExists':
            }
        });
    }

    protected displaySagepayMessage(): void {
        if (typeof window !== 'undefined') {
            // eslint-disable-next-line @typescript-eslint/quotes
            window.alert("Sorry, but for safety reasons you can't sign in or register using this device");
        }
    }
}
